<template>
  <div id="menuBar">
    <div id="">
      <el-button @click="addClick()" type="primary" icon="el-icon-edit" size="mini">添加</el-button>
      <el-button @click="delentClick()" type="danger" icon="el-icon-delete" size="mini">删 除</el-button>
      <el-dialog v-dialogDrag  title="添加菜单" :visible.sync="dialogVisible" width="30%">
        <el-form ref="form" :model="sizeForm" label-width="100px" size="mini">
          <el-form-item label="菜单名">
            <el-input v-model="sizeForm.name" placeholder="请输入菜单名"></el-input>
          </el-form-item>
          <el-form-item label="菜单路径名">
            <el-input v-model="sizeForm.page" placeholder="请输入所需跳转路径"></el-input>
          </el-form-item>
          <el-form-item label="选择一级菜单" v-if="showDown">
            <el-select v-model="sizeForm.region" placeholder="请选择" >
              <el-option v-for="(item,index) in options" :key="index" :label="item.name" :value="item.GZL_MENU_id_PK">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="菜单等级" prop="resource">
            <el-radio-group v-model="sizeForm.resource" @change="changeRadio()">
              <el-radio label="一级菜单"></el-radio>
              <el-radio label="二级菜单"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="活动形式">
            <el-input type="textarea" v-model="sizeForm.description"></el-input>
          </el-form-item>
          <el-form-item size="large">
            <el-button @click="cancal">取 消</el-button>
            <el-button type="primary" @click="saveClick()">保存</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <el-table :data="options"  border style="width: 100%" :height="TableHeight" v-loading="loading"  element-loading-text="拼命加载中">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table :data="props.row.oo"  border style="width: 100%" :header-cell-style="{background:'#ff9766',color:'#000000'}">
            <!-- <el-table-column prop="GZL_MENU_id_PK" label="ID" width="180">
            </el-table-column> -->
            <el-table-column prop="name" label="菜单名" align="center">
            </el-table-column>
            <el-table-column prop="parent_id" label="父级菜单ID" align="center">
            </el-table-column>
            <el-table-column prop="page" label="路径" align="center">
            </el-table-column>
            <el-table-column prop="description" label="备注" align="center">
            </el-table-column>
            <el-table-column label="操作" width="250" align="center">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="primary" icon="el-icon-edit" size="small">编 辑</el-button>
                <el-button @click="delentClick(scope.row)" type="danger" icon="el-icon-delete" size="small">删 除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="GZL_MENU_id_PK" label="ID" align="center">
      </el-table-column>
      <el-table-column prop="name" label="菜单名" align="center">
      </el-table-column>
      <el-table-column prop="parent_id" label="父级菜单ID" align="center">
      </el-table-column>
      <el-table-column prop="page" label="路径" align="center">
      </el-table-column>
      <el-table-column prop="description" label="备注" align="center">
      </el-table-column>
      <el-table-column label="操作" width="250" align="center">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="primary" icon="el-icon-edit" size="mini">编 辑</el-button>
          <el-button @click="delentClick(scope.row)" type="danger" icon="el-icon-delete" size="mini">删 除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog v-dialogDrag  title="修改菜单" :visible.sync="dialogVisibleTOW" width="30%">
      <el-form ref="form" :model="sizeForm" label-width="100px" size="mini">
        <el-form-item label="菜单名">
          <el-input v-model="sizeForm.name" placeholder="请输入菜单名"></el-input>
        </el-form-item>
        <el-form-item label="菜单路径名">
          <el-input v-model="sizeForm.page" placeholder="请输入所需跳转路径"></el-input>
        </el-form-item>
        <el-form-item label="选择一级菜单">
          <el-select v-model="sizeForm.region" placeholder="请选择" @change="changecity()">
            <el-option v-for="(item,index) in options" :key="index" :label="item.name" :value="item.GZL_MENU_id_PK">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单等级" prop="resource" @change="changeRadio()">
          <el-radio-group v-model="sizeForm.resource">
            <el-radio label="一级菜单"></el-radio>
            <el-radio label="二级菜单"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动形式">
          <el-input type="textarea" v-model="sizeForm.description"></el-input>
        </el-form-item>
        <el-form-item label="菜单排序">
          <el-input v-model="sizeForm.sortid"></el-input>
        </el-form-item>
        <el-form-item size="large">
          <el-button @click="cancal">取 消</el-button>
          <el-button type="primary" @click="saveClick()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script scoped>
  import {
    UserPage
  } from '../../static/API/API.js'
  export default {
    data() {
      return {
        tableData: [],
        dialogVisible: false,
        dialogVisibleTOW: false,
        sizeForm: {
          name: '',
          page: '',
          region: '',
          programme: '',
          resource: '一级菜单',
          description: ''
        },
        options: [],
        parent:[],
        value: '',
        input: '',
        ope_type: '',
        showDown: false,
        loading:false,
        TableHeight:490
      }
    },
    methods: {
      changeRadio(row) {
         this.$set(this.sizeForm,this.sizeForm.resource,this.sizeForm.resource)
        console.log(this.showDown)
        if (this.sizeForm.resource == '二级菜单') {
          this.showDown = true
          console.log(this.showDown)
        }

      },
      changecity(){
        console.log(this.sizeForm.region)
       this.$set(this.sizeForm,this.sizeForm.region,this.sizeForm.region)
      },
      addClick() {
        this.dialogVisible = true
        this.ope_type = '添加'
      },
      saveClick() {
        this.dialogVisibleTOW=false
        this.dialogVisible = false
        let params = new URLSearchParams()
        if (this.ope_type == '修改') {
          params.append('GZL_MENU_id_PK', this.sizeForm.GZL_MENU_id_PK)
        }
        params.append('ope_type', this.ope_type)
        params.append('name', this.sizeForm.name)
        params.append('des', this.sizeForm.description)
        params.append('page', this.sizeForm.page)
        params.append('sortid', this.sizeForm.sortid)
        params.append('is_delete', 0)
        if (!this.sizeForm.resource || this.sizeForm.resource == '一级菜单') {
          params.append('parent_id', 0)
        } else {
          params.append('parent_id', this.sizeForm.region)
        }
        //'http://192.168.44.7:6001/pages/'
        this.$axios.post(UserPage, params).then(res => {
          this.$message({
            message: res.data,
            type: 'success',
            duration: 1000,
            showClose: true,
          });
          this.sizeForm = {}
          // this.pagefeed()
        })
      },
      handleClick(row) {
        this.dialogVisibleTOW = true
        this.sizeForm = row
        console.log(this.sizeForm)
        if (this.sizeForm.parent_id != 0) {
          this.sizeForm.resource = '二级菜单'
          this.options.forEach(e => {
            console.log(e.GZL_MENU_id_PK == this.sizeForm.parent_id)
            if (e.GZL_MENU_id_PK == this.sizeForm.parent_id) {
              this.sizeForm.region = e.GZL_MENU_id_PK
              // console.log(e.name)
            }
          })
        }
        console.log(this.sizeForm)
        this.ope_type = '修改'
        // let params = new URLSearchParams()
        // params.append('ope_type', '修改')
        // params.append('is_delte', 1)
        // params.append('GZL_MENU_id_PK', row.GZL_MENU_id_PK)
        // this.$axios.post(UserPage, params).then(res => {
        //   this.$message({
        //     message: res.data,
        //     type: 'success'
        //   });
        //   this.pagefeed()
        // })
      },
      delentClick(row) {
        let params = new URLSearchParams()
        params.append('ope_type', '删除')
        params.append('is_delete', 1)
        params.append('GZL_MENU_id_PK', row.GZL_MENU_id_PK)
        this.$axios.post(UserPage, params).then(res => {
          this.$message({
            message: res.data,
            type: 'success',
            duration: 1000,
            showClose: true,
          });
          this.pagefeed()
        })
      },
      // 取消
      cancal() {
        this.options=[]
        this.sizeForm = {}
        this.dialogVisibleTOW = false
        this.dialogVisible = false
        this.pagefeed()
      },

      pagefeed() {
        this.loading = true
        let par =[]
        let params = new URLSearchParams()
        params.append('ope_type', '目录')
        this.$axios.post(UserPage, params).then(res => {
          console.log(res.data)
          this.options=[]
          res.data.forEach(item => {
            item.oo=[]
            if (item.parent_id == 0) {
              this.options.push(item)
            }
          })
          this.options.forEach(e =>{
            res.data.forEach(item => {
              if(e.GZL_MENU_id_PK == item.parent_id){
               e.oo.push(item)
              }
            })
          })
          setTimeout(() => {
            this.loading = false
          }, 300);
        })
      },
      getHeight(){
    //动态计算表格高度
    this.$nextTick(()=>{
      let windowHeight = document.documentElement.clientHeight || document.bodyclientHeight;
    this.TableHeight = windowHeight - 177;//数值"140"根据需要调整
    })
      },
    },
    created () {
    window.addEventListener('resize', this.getHeight)
  },
    destroyed () {
    window.removeEventListener('resize', this.getHeight)
  },
    mounted() {
      this.pagefeed()
      this.getHeight()
    },
  }
</script>

<style scoped>
  .input {
    margin-top: 0.9375rem;
    width: 40.5rem;
    ;
  }

  .el-input-group__append,
  .el-input-group__prepend {
    width: 0.0625rem;
    background-color: #419eff;
    color: white;
    display: table-cell;
    position: relative;
    padding: 0 1.25rem;
    white-space: nowrap;
    border-radius: 1.5625rem;
  }

  /* .el-select .el-input {
    width: 130px;
  } */
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

  .el-form-item__label {
    width: 8.75rem !important;
  }

  .select {
    width: 25rem !important;
  }

  .el-select-dropdown {
    max-width: 2.5rem;
    width: 25rem;
    transform-origin: center top;
    z-index: 2009;
    position: absolute;
    top: 28.5625rem;
    left: 57.25rem
  }

  .el-select-dropdown__item {
    overflow: visible;
  }
</style>



// WEBPACK FOOTER //
// src/views/menuBar.vue